"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arr = void 0;
exports.Arr = Object.freeze({
    empty: Object.freeze([]),
    at: function (arr, index) {
        if (arr.length === 0)
            return undefined;
        while (index < 0)
            index += arr.length;
        return arr[index % arr.length];
    },
    first: function (arr) {
        return arr[0];
    },
    last: function (arr) {
        return arr[arr.length - 1];
    },
    findLowest: function (arr, callback) {
        var n = Number.MAX_SAFE_INTEGER;
        var e = null;
        for (var i = 0; i < arr.length; i++) {
            var v = callback(arr[i], i);
            if (v >= n)
                continue;
            n = v;
            e = arr[i];
        }
        return e;
    },
    findLast: function (arr, predicate) {
        for (var i = arr.length - 1; i >= 0; i--) {
            if (predicate(arr[i])) {
                return arr[i];
            }
        }
        return null;
    },
    for: function (arr, callback) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < arr.length; i++) {
            callback(arr[i], i);
        }
    },
    rfor: function (arr, callback) {
        for (var i = arr.length - 1; i >= 0; i--) {
            callback(arr[i], i);
        }
    },
    replace: function (arr, newItems) {
        arr.splice.apply(arr, __spreadArray([0, arr.length], __read(Array.from(newItems)), false));
    },
    clear: function (arr) {
        arr.splice(0, arr.length);
    },
    append: function (arr, items) {
        var e_1, _a;
        try {
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var tm = items_1_1.value;
                arr.push(tm);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    },
    addIfNotMatch: function (arr, tm, predicate) {
        if (!!arr.find(function (x) { return predicate(x); }))
            return false;
        arr.push(tm);
        return true;
    },
    remove: function (arr, tm) {
        var i = arr.indexOf(tm);
        if (i < 0)
            return false;
        arr.splice(i, 1);
        return true;
    },
    removeWhere: function (arr, predicate) {
        for (var i = 0; i < arr.length; i++) {
            if (predicate(arr[i])) {
                arr.splice(i, 1);
                i--;
            }
        }
    },
    split: function (arr, primaryPredicate) {
        var e_2, _a;
        var p = [];
        var s = [];
        try {
            for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var x = arr_1_1.value;
                (primaryPredicate(x) ? p : s).push(x);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [p, s];
    },
    flatten: function (arr, result) {
        if (result === void 0) { result = []; }
        for (var i = 0, length_1 = arr.length; i < length_1; i++) {
            var value = arr[i];
            if (Array.isArray(value)) {
                exports.Arr.flatten(value, result);
            }
            else {
                result.push(value);
            }
        }
        return result;
    },
    keyBy: function (arr, key) {
        return arr.reduce(function (t, x) {
            t[x[key]] = x;
            return t;
        }, {});
    },
    groupBy: function (arr, key) {
        return arr.reduce(function (t, x) {
            (t[x[key]] = t[x[key]] || []).push(x);
            return t;
        }, {});
    },
    sortBy: function (arr, key, dir) {
        if (dir === void 0) { dir = 'asc'; }
        return arr.slice().sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            var r = 0;
            if (x < y)
                r = -1;
            if (x > y)
                r = 1;
            return dir === 'asc' ? r : r * -1;
        });
    },
    equals: function (a, b) {
        if (a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    },
    random: function (a, rand) {
        rand = rand || Math.random;
        return a[Math.floor(rand() * a.length)];
    },
    move: function (arr, from, to) {
        var startIndex = from < 0 ? arr.length + from : from;
        if (startIndex >= 0 && startIndex < arr.length) {
            var endIndex = to < 0 ? arr.length + to : to;
            var _a = __read(arr.splice(from, 1), 1), item = _a[0];
            arr.splice(endIndex, 0, item);
        }
    },
    max: function (arr, comp) {
        var e_3, _a;
        if (!arr.length)
            return null;
        var m = arr[0];
        try {
            for (var arr_2 = __values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                var x = arr_2_1.value;
                if (comp(m, x) > 0)
                    m = x;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (arr_2_1 && !arr_2_1.done && (_a = arr_2.return)) _a.call(arr_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return m;
    },
    avg: function (arr) {
        return arr.reduce(function (p, c) { return p + c; }, 0) / arr.length;
    },
    mode: function (arr) {
        var e_4, _a;
        var map = new Map();
        var max = 0;
        var mode = null;
        try {
            for (var arr_3 = __values(arr), arr_3_1 = arr_3.next(); !arr_3_1.done; arr_3_1 = arr_3.next()) {
                var x = arr_3_1.value;
                var count = map.get(x) || 0;
                map.set(x, count + 1);
                if (count > max) {
                    max = count;
                    mode = x;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (arr_3_1 && !arr_3_1.done && (_a = arr_3.return)) _a.call(arr_3);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return mode;
    },
    unique: function (arr, key) {
        var e_5, _a;
        key = key || (function (x) { return x; });
        var res = [];
        var set = new Set();
        try {
            for (var arr_4 = __values(arr), arr_4_1 = arr_4.next(); !arr_4_1.done; arr_4_1 = arr_4.next()) {
                var x = arr_4_1.value;
                var k = key(x);
                if (!set.has(k)) {
                    set.add(k);
                    res.push(x);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (arr_4_1 && !arr_4_1.done && (_a = arr_4.return)) _a.call(arr_4);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return res;
    },
    // https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
    shuffle: function (array, rand) {
        var _a;
        rand = rand || Math.random;
        var currentIndex = array.length;
        var randomIndex = 0;
        // While there remain elements to shuffle...
        while (currentIndex !== 0) {
            // Pick a remaining element...
            randomIndex = Math.floor(rand() * currentIndex);
            currentIndex--;
            // And swap it with the current element.
            _a = __read([
                array[randomIndex], array[currentIndex]
            ], 2), array[currentIndex] = _a[0], array[randomIndex] = _a[1];
        }
        return array;
    },
});
